var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',{staticClass:"pr-0"},[_c('Header'),_c('v-content',{staticClass:"pr-0"},[_c('router-view'),_c('Sign_In')],1),_c('Footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }